import { ComponentBread, ComponentHeader, DeleteIcon, StyledCreate } from "@components";
import { PATH_COUPON_LIST, PATH_CREATE_COUPON_FAMILY } from "@configs";
import { CdicServiceForm } from "@modules/coupon/Service";
import {
  getApiErrorMessage,
  useDeleteService,
  useNotify,
  useProgramDetail,
  useServiceNames,
} from "@utils";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import styled from "styled-components";
import { ICouponService } from "@interfaces";

export const PageCreateCdicService = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { error } = useNotify();
  const { data: coupon } = useProgramDetail(id);
  const { data: service = [] as ICouponService[], refetch } = useServiceNames();
  const deleteService = useDeleteService();

  const data = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={"/"}>{t("page.selected_program_name")}</a>,
    },
    {
      title: <a href={PATH_CREATE_COUPON_FAMILY}>{t("page.create_service")}</a>,
    },
  ];

  const handleDelete = async (serviceId: string) => {
    try {
      await deleteService.mutateAsync(serviceId);
      refetch();
    } catch (err) {
      error(getApiErrorMessage(err, t("message.update.fail")));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.create_coupon_family")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CdicServiceForm coupon={coupon} onSuccess={refetch} />
        <div>
          {(service as ICouponService[]).map((item, index) => (
            <StyledList key={item._id}>
              <div>{index + 1}</div>
              <p>{item.serviceName}</p>
              <Button
                onClick={() => item._id && handleDelete(item._id)}
                type="primary"
                icon={<DeleteIcon />}
              />
            </StyledList>
          ))}
        </div>
      </StyledCreate>
    </>
  );
};

const StyledList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 200px;
  border-bottom: 1px solid #d9d9d9;
  p {
    margin: 0;
  }
`;
